import Template from "components/Template";
import React from "react";

export const ErrorPageTemplate: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    // Useless can just use template?
    return <Template>{children}</Template>;
};
